"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get LlmLogModel () {
        return LlmLogModel;
    },
    get LlmLogStatus () {
        return LlmLogStatus;
    },
    get LlmResponseStyle () {
        return LlmResponseStyle;
    },
    get TriggeredBySchema () {
        return TriggeredBySchema;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const LlmResponseStyle = _zod.z.enum([
    "text",
    "structured",
    "embeddings"
]);
const TriggeredBySchema = _zod.z.union([
    _zod.z.object({
        type: _zod.z.literal("user"),
        user_id: _zod.z.instanceof(_bson.ObjectId)
    }),
    _zod.z.object({
        type: _zod.z.literal("automation")
    }),
    _zod.z.object({
        type: _zod.z.literal("migration")
    })
]);
const LlmLogStatus = _zod.z.enum([
    "waiting",
    "in_progress",
    "completed",
    "error"
]);
const LlmLogModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    created_at: _zod.z.date(),
    // Identification
    company_id: _zod.z.instanceof(_bson.ObjectId),
    user_id: _zod.z.instanceof(_bson.ObjectId).nullable(),
    triggered_by: TriggeredBySchema.nullable(),
    // Prompt context
    type: LlmResponseStyle,
    prompt_name: _zod.z.string(),
    prompt: _zod.z.string(),
    prompt_variables: _zod.z.record(_zod.z.string(), _zod.z.any()),
    prompt_hash: _zod.z.string().nullable(),
    // LLM metadata
    llm_model: _zod.z.string(),
    llm_response: _zod.z.string().or(_zod.z.record(_zod.z.string(), _zod.z.any())),
    // Usage & metrics
    usage: _zod.z.record(_zod.z.string(), _zod.z.any()),
    // Any other runtime info (retry flags, flags, etc.)
    context: _zod.z.record(_zod.z.string(), _zod.z.any()),
    batches: _zod.z.array(_zod.z.object({
        log_id: _zod.z.instanceof(_bson.ObjectId),
        status: LlmLogStatus,
        lease_time: _zod.z.date().optional()
    }))
});
